export const SWITCH_RFP_CHAT_DIALOG = "SWITCH_RFP_CHAT_DIALOG";
export const GET_RFP_MESSAGES = "GET_RFP_MESSAGES";
export const CREATE_RFP_MESSAGE = "CREATE_RFP_MESSAGE";
export const ADD_RFP_MESSAGE = "ADD_RFP_MESSAGE";
export const GET_CUSTOMER_RFP_CHATS = "GET_CUSTOMER_RFP_CHATS";
export const GET_RFP_CHAT_MESSAGES = "GET_RFP_CHAT_MESSAGES";
export const UPDATE_RFP_MESSAGE = "UPDATE_RFP_MESSAGE";